import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { type FacetsResponse } from '../models/facets.response';
import { map, type Observable } from 'rxjs';
import { UserFacade } from 'src/app/_core/state/user/user.facade';
import { LocaleService } from 'src/app/services/locale.service';
import { FacetsFactory } from './facets.factory';
import type { FacetsData } from '../models/facets.model';
import type { FacetsStateModel } from '../facets.state';
import type { FacetsRequestParams } from '../models/facets.request';

@Injectable({
  providedIn: 'root',
})
export class FacetsService {
  private readonly httpClient = inject(HttpClient);
  private readonly userFacade = inject(UserFacade);
  private readonly localeService = inject(LocaleService);
  private readonly facetsFactory = inject(FacetsFactory);

  getFacets(previousState: FacetsStateModel, filters?: string, query?: string): Observable<FacetsData> {
    const url = `${environment.apiUrl}/facets`;

    const patronId = this.userFacade.user?.id ?? null;
    const params: Partial<FacetsRequestParams> = {
      locale: this.localeService.language,
      ...(patronId && { patronId }),
      ...(filters && { filters }),
      ...(query && { query }),
    };

    return this.httpClient
      .get<FacetsResponse>(url, { params })
      .pipe(map((response) => this.facetsFactory.buildFacetsData(response, previousState)));
  }
}
